import { createSelector } from "reselect";
import { getSelected, CUSTOMERS, invite } from "../reducers";
import { CustomerResponseInterface } from "@careapp/angular-sdk";

export const getInvitesForCustomer = createSelector(
  getSelected(CUSTOMERS),
  invite.getPending,
  (customer, invites) =>
    invites.filter(
      invite =>
        (<any>invite).permissions != null &&
        (<Array<any>>(<any>invite).permissions).filter(
          permission =>
            permission.modelId == (<CustomerResponseInterface>customer).id
        ).length > 0
    )
);
